import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import {
    ProjectAccessMode,
    ProjectSystemType,
    ProjectSystemTypeIcon,
    ProjectSystemTypeName,
    TEMPLATE_CONTENT_DEFAULT,
    TemplateContent
} from "./types";
import ProjectSettings from "../../manager/project/project-settings/project-settings";
import ProjectViewsLookup from "./inheritance/project-views-lookup";
import {SystemStatus} from "../../gd/const/system-status";
import {ProjectAccess, ProjectIconDictionary, ProjectRole} from "../../gd/const/project";
import ProjectProperties from "./properties/project-properties";
import TaskTypesLookup from "./inheritance/task-types";
import TasksStatusesLookup from "./inheritance/task-statuses";
import CRMAccountLookup from "./inheritance/crm-account";
import ProjectStatusesLookup from "./inheritance/project-statuses";
import {ProjectAccessControl} from "./access/acl";
import {projectSessionApplyDelta} from "./functions/session-delta"
import ProjectPropertiesFactory from "./properties/properties-factory";
import asyncSessionLoader from "../../gd/data/async-session-loader"
import ProjectViews from "../project-view/project-views"
import ProjectSessionCollection from "./collection"
import {projectLinkGoTo} from "./properties/link/goto-project-link";
import Workspace from "../space/workspaces/workspace";
import {SpaceProto} from "../space/space-proto";
import {ItemDisplay, ItemDisplayDict} from "../item/item-model";
import {ColorPalette} from "../../fields3/color-coding/color-coding";
import SessionProjectUsers from "../../gd-model/project-user/project-users";
import ProjectUser from "../project-user/project-user";
import {SourceType} from "./inheritance/project-property-lookup"
import {REPORT_VIEW_TYPES} from "../../gd/const/views/view-type";

export default class ProjectSession extends ModelEntity {

    public name                 : string
    public icon                 : string    // chto to staroe ... tipo attachment ???
    public projectIcon          : string   // smotri project.icon const

    public color                : number
    public companyId            : ID
    public parentId             : ID | null          // is it parent projectId ? so it can be null ?

    public systemStatus         : SystemStatus
    public statusId             : ID       // project status ID

    public systemType           : ProjectSystemType    // chto takoe system type ? folder / spint project ? nado zibavitsya budet
    public isTemplate           : boolean

    public shortName            : string     // ochen' neponyatno - skoree vsego ne nuzno ? ili nuzno ? initials ?



    public access               : ProjectAccess // used to be optional ... hmmm... used in session only .... i v gantt gde to bili zapisi strannie...
    public role                 : ProjectRole   // used in session only ?
    public accessMode           : ProjectAccessMode     //

    public description          : string


    public projectTypeId        : ID  // a chto eto takoe ? A YA NE ZNAU !!! stranno.... dumau eto ne osobo uzaetsya no nado check, vozmozno eto project Tempalte id ???

    public sortPosition         : number   // eto po idee nado vezde ....

    public keywords             : string      // i dont' think we use, original purpose search by project with this field. dumau mozno udalit' no proevit' nado !

    public statuses             : any[] // I think this is prtoject workflow
    public settings             : ProjectSettings | null // null always mean not loaded ?????
    public taskStatusesOverride : ID[] // po moemu eto custom taskIds when ovveride worflow for tasks
    public taskTypes            : ID[]


    // ya tak dumau eto custom fields dlya TASKS v etom project
    public customFields           : ID[] // eto ne data a custom fields dlua tasks


    // ok po hodu edinstvennii use seichas eto treatAsCatalog ...
    // v celom vozmozno eto nado ostavit' - kto znaet chto eche v session data budet nuzno
    // nefiga = nogo chego tam vrode
    public properties               : ProjectProperties

    public isDeleted?              : boolean // ggde to uzaetsya

    public crmAccountId?            : ID
    public isCRMAccountInherited    : boolean = false

    public localTemplateId?         : ID   // project type - bilo napisano chto session.tempalte only  not sure...
    public sharedTemplateId?        : ID   // session.tempalte only
    public templateContent?         : TemplateContent

    // Tree related
    public treeChildren             : ProjectSession[] = []
    public treeParent?              : ProjectSession

    public treeDisplay              : ItemDisplay = ItemDisplay.VISIBLE
    public treeIsExpandedProjectSelector    : boolean = false       // used in project selector and other places like this but not in main menu!
    // End Tree

    constructor(data:any) {
        super(data['id'], EntityType.PROJECT);

        // this.id                     = data['id']

        this.name                   = data['name']
        this.icon                   = data['icon']    // ??? ya dumau eto old icon kot. zalivaetsya grafika

        this.color                  = data['color']
        this.companyId              = data['companyId']
        this.parentId               = data['parentId']
        this.projectIcon            = data['projectIcon']   // see project.icon const

        this.systemStatus           = data['systemStatus']
        this.statusId               = data['statusId']       // project status ID

        this.systemType             = data['systemType']    // chto takoe system type ? folder / spint project ? nado zibavitsya budet
        this.isTemplate             = _.get(data,'isTemplate')

        this.description            = data['description']

        this.shortName              = data['shortName']     // ochen' neponyatno - skoree vsego ne nuzno ? ili nuzno ? initials ?

        this.projectTypeId          = data['projectTypeId']

        this.sortPosition           = data['sortPosition']   // eto po idee nado vezde ....

        this.keywords               = data['keywords']      // i dont' think we use, original purpose search by project with this field. dumau mozno udalit' no proevit' nado !

        this.statuses               = data['statuses']

        this.settings               = data['settings'] ? new ProjectSettings(this, data['settings']) : null
        // if (!this.settings)


        this.taskStatusesOverride   = data['taskStatusesOverride']
        this.taskTypes              = data['taskTypes'] ? data['taskTypes'] : []

        // ya tak dumau eto custom fields dlya TASKS v etom project
        this.customFields           = data['customFields'] ? data['customFields'] : []



        this.access                 = data['access']
        this.role                   = data['role']                                          // user role in cur project
        this.accessMode             = data['accessMode']

        // this.properties = ProjectPropertiesData.normalize(data['properties']) - old way
        this.properties             = ProjectPropertiesFactory.get(data['systemType'], data['properties'], this) // - new way

        this.crmAccountId           = data['crmAccountId'] || undefined
        if (!this.crmAccountId) {
            const crmAccountLookup = new CRMAccountLookup(this.id)
            this.crmAccountId           = crmAccountLookup.get()
            this.isCRMAccountInherited  = crmAccountLookup.sourceType === SourceType.INHERITED
        }

        this.localTemplateId        = data['localTemplateId']   // project type
        this.sharedTemplateId       = data['sharedTemplateId']   // project type

        if (this.isTemplate) {
            this.templateContent    = _.get(data, 'templateContent', TEMPLATE_CONTENT_DEFAULT)
        }
    }

    get colorRGB():string {

        return gd.skin.colors.mainColor({
            colorNumber : this.color,
            corePalette : ColorPalette.CORE
        })
    }

    get link():string {
        return 'https://www.goodday.work/p/{0}'.f(this.id)
    }

    // tree getters

    get treeHasChildren():boolean {
        return !_.isEmpty(this.treeChildren)
    }

    get treeHasNotArchivedChildren():boolean {
        let result : boolean = false

        _.map(this.treeChildren, (project : ProjectSession) => {
            if (!project.isArchived) {
                result = true
            }
        })

        return result
    }

    get treeHasVisibleChildren():boolean {
        let result : boolean = false

        _.map(this.treeChildren, (project : ProjectSession) => {
            if ([ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(project.treeDisplay)) {
                result = true
            }
        })

        return result
    }

    get treeIsGhost():boolean {
        return [ItemDisplay.GHOST_HIDDEN, ItemDisplay.GHOST_VISIBLE].includes(this.treeDisplay)
    }

    get treeIsHidden():boolean {
        return this.treeDisplay === ItemDisplay.HIDDEN
    }

    // End

    // ACCESS

    get acl():ProjectAccessControl {
        return new ProjectAccessControl(this)
    }

    canCreateTask() {
        return this.acl.canCreateTask
    }

    canCreateProject() {
        return this.acl.canCreateProject
    }

    canAddProjectUsers() {
        return this.acl.canAddProjectUsers
    }

    get accessModeIsPublic() {
        return this.accessMode === ProjectAccessMode.PUBLIC_INHERITANCE_CHILDREN || this.accessMode === ProjectAccessMode.PUBLIC_INHERITANCE_NONE
    }

    // End Access

    get rootParent():ProjectSession | null {

        if (!this.treeParent) return null

        const getParent = (project:ProjectSession):ProjectSession | null => {
            if (!project.treeParent) {
                return project
            } else {
                return getParent(project.treeParent)
            }
        }

        const rootParent: ProjectSession | null = getParent(this)
        return rootParent
    }

    get space():SpaceProto {

        // because clients see all Workspace projects in Projects space
        if (!gd.user.acl.isClient) {
            const workspace = this.workspace

            if (workspace) {
                return workspace
            }

            if (this.isTag && !gd.spaces.projects.enabled) {
                return gd.spaces.tools
            }
        }

        return gd.spaces.projects
    }

    get workspace():Workspace | null {

        const rootParent = this.rootParent

        if (rootParent?.isWorkspace) {
            return gd.spaces.workspaces.getByProject(rootParent)
        }

        // workspace itself
        if (!rootParent && this.isWorkspace) {
            return gd.spaces.workspaces.getByProject(this)
        }

        return null
    }

    // in root like projects space or something else ....
    get isRoot(): boolean {

        if (!this.parentId) return true // projects space root

        return false
    }

    // level 1 in workspace
    get isWorkspaceRoot(): boolean {

        const rootParent = this.rootParent

        // workspace root
        if (rootParent?.isWorkspace && this.parentId === rootParent?.id) {
            return true
        }

        return false
    }

    // some projects dont have menu like, category, cusotmView, etc
    get hasMenu():boolean {
        if (this.isLink || this.isView) return false
        return true
    }

    get isOpen() {
        return gd.const.systemStatus.isOpen(this.systemStatus)
    }

    get isClosed() {
        return !this.isOpen
    }

    get url() {
        return "p/"+this.id;
    }

    // a zachem eto ? hez... v session project bilo
    get systemStatusName() {
        return gd.const.systemStatusList[this.systemStatus];
    }

    get systemTypeName():string {
        return ProjectSystemTypeName[this.systemType]
    }

    get isArchived() {
        return gd.const.systemStatus.isClosed(this.systemStatus);
    }

    // this is old - nado so vremenem izvavitsya ot etogo budet (big screens, nalytics)
    get initials() {
        return gd.utils.initials(this.name,3);
    }

    get iconClass() {

        if (this.projectIcon) {
            return gd.const.project.icon[this.projectIcon]
        }

        // no icon set - get system icon from system type
        return ProjectIconDictionary[ProjectSystemTypeIcon[this.systemType] as keyof object]
    }

    get isProject() {return this.systemType === ProjectSystemType.PROJECT}
    get isWorkspace() {return this.systemType === ProjectSystemType.WORKSPACE}
    get isFolder() {return this.systemType === ProjectSystemType.FOLDER}
    get isTag() {return this.systemType === ProjectSystemType.TAG}

    get isGlobalTag() {
        return this.isTag && !this.parentId // no parent means global tag
    }

    get isCategory() {return this.systemType === ProjectSystemType.CATEGORY}
    get isPage() {return this.systemType === ProjectSystemType.PAGE}
    get isLink() {return this.systemType === ProjectSystemType.LINK}
    get isEmbed() {return this.systemType === ProjectSystemType.EMBED}
    get isView() {return this.systemType === ProjectSystemType.VIEW}

    get isReport():boolean {
        return this.systemType === ProjectSystemType.REPORT_VIEW
    }

    get path():ProjectSession[] {

        const parents : ProjectSession[] = []

        const recursiveFindParent = (project:ProjectSession) => {

            if (project.treeParent) {
                parents.push(project.treeParent)
                recursiveFindParent(project.treeParent)
            }
        }

        recursiveFindParent(this)

        parents.reverse()

        // add project itself this is full path
        parents.push(this)

        return parents

    }

    // Inheretance lookups... in futre do GETTERs  here
    getInheritedTaskTypes()     {return new TaskTypesLookup(this.id).get()}
    getInheritedStatuses()      {return new ProjectStatusesLookup(this.id).get()}
    getInheritedTaskStatuses()  {return new TasksStatusesLookup(this.id).get()}
    getInheritedViews()         {
        return new ProjectViewsLookup(this.id).get()
    }
    getInheritedCRMAccount()    {return new CRMAccountLookup(this.id).get()}

    get hasAccess() {
        if (this.access) {
            const projectUser = gd.session.projectUsers.findByProjectAndUser(this.id, gd.user.id)
            return !!projectUser?.access
        }

        return false
    }

    get hasAccessibleChildren(): boolean {
        const checkAccessible = (projects:ProjectSession[]):boolean => (
            _.some(projects, (project:ProjectSession)=>{
                if (project.hasAccess) {
                    return true
                } else if (project.treeChildren) {
                    return checkAccessible(project.treeChildren)
                }
                return false
            })
        )

        return checkAccessible(this.treeChildren)
    }


    // go to edit view page (LINK or EMBED system type only)
    async editSource() {
        if (this.isEmbed) {
            await asyncSessionLoader(gd.session.findMissing({
                projectsSettings: [this.id]
            }))

            const projectViews = ProjectViews.initByProjectId(this.id)
            const view = projectViews.getFirst() // embed project has only one view
            view.edit()
        } else if (this.isLink) {
            gd.navigation.goTo('p/{0}/link/edit'.f(this.id))
        }
    }

    applyDelta(data:any) {
        return projectSessionApplyDelta(this, data)
    }

    initTree(projectSessionCollection:ProjectSessionCollection = gd.session.projects) {
        let parent  : ProjectSession | null = null

        // ok... treeRots & rootProjectIds
        // koroche eto case kogda proekt est' v projectIds no on sub folder of other rootProjectIds
        // patch projectSessionCollection_structurePatch(projectSessionCollection) - not in use...
        // i tut mi based on concept chto esli project tree to v collection ego NETU(!)

        if (!this.parentId) {
            // console.orange(item.debugName, "is root")
            // projectSessionCollection is table root Item
            // we DO not set tree parent

            // console.orange("item.project.parentId is empoty->add to roots")
            this.treeParent         = undefined
            // project.isRoot             = true
            projectSessionCollection.treeRoots.push(this) // add to tree roots !

        } else {
            parent = projectSessionCollection.get(this.parentId)
            if (parent) {
                this.treeParent = parent
            }
        }

        if (this.treeParent) {
            this.treeParent.treeChildren.push(this)
        }
    }

    markParentsAsVisibleGhosts():void {

        const recuriveMarkParents = (project?:ProjectSession) => {
            if (!project) return

            // skip already visible
            if (project.treeDisplay === ItemDisplay.VISIBLE) {
                // do nothing
            } else {
                project.treeDisplay = ItemDisplay.GHOST_VISIBLE
            }

            recuriveMarkParents(project.treeParent)


        }

        recuriveMarkParents(this.treeParent)

    }

    get parentProjectsIds(): ID[] {
        let res: ID[] = []
        const recursiveGetParents = (project?:ProjectSession) => {
            if (!project) return

            res.push(project.id)

            recursiveGetParents(project.treeParent)
        }

        recursiveGetParents(this.treeParent)

        return res
    }

    get childrenProjectsIds(): ID[] {
        let res: ID[] = []
        const recursiveGetChildren = (projects?:ProjectSession[]) => {
            _.map(projects, (project: ProjectSession) => {
                if (!project) return

                res.push(project.id)

                recursiveGetChildren(project.treeChildren)
            })
        }

        recursiveGetChildren(this.treeChildren)

        return res
    }

    copyUrl() {
        gd.utils.copyToClipboard(this.link)
        gd.growl.success("{0} link copied to clipboard".f(this.name))
    }

    toJSON() {
        let res: JSONObject = {}

        _.mapKeys(this, (value:any, key)=>{
            switch (key) {
                case 'properties'       :
                    res.properties = this.properties.toJSON()
                    break

                case 'settings'         :
                    if (this.settings) {
                        res.settings = this.settings.toJSON()
                    }
                    break

                case 'treeChildren':
                case 'treeParent':
                    // we must skip this properties
                    break

                default:
                    res[key] = value
            }

        })

        return res
    }

    toOption():Option {
        return {
            label   : this.name,
            value   : this.id,
            icon    : this.iconClass
        }
    }

    // Old methods from session - find usage and remove to model...
    toModel() {
        // return new Project(this)

        return this
    }

    // return all user ids in this project
    userIds(minAccess?:ProjectAccess):ID[] {

        const projectUsers : SessionProjectUsers = gd.session.projectUsers.filterByProject(this.id, minAccess)

        const userIds: ID[] = projectUsers.models.map((projectUser:ProjectUser) => {
            return projectUser.user.id
        })

        return userIds
    }

    get usersTotal():number {
        const projectUsers : SessionProjectUsers = gd.session.projectUsers.filterByProject(this.id)
        return projectUsers ? projectUsers.length : 0;
    }

    goTo() {

        switch (this.systemType) {

            case ProjectSystemType.CATEGORY:
            case ProjectSystemType.WORKSPACE:
                return null

            case ProjectSystemType.LINK:
                return projectLinkGoTo(this)

            case ProjectSystemType.VIEW:
                // regular resource view
                gd.navigation.goToProject(this.id)
                return

            case ProjectSystemType.REPORT_VIEW:
                gd.navigation.goToProject(this.id)

            default:
                gd.navigation.goToProject(this.id)
        }

    }

    goToInfo() {
        gd.navigation.goToProject(this.id, '/info')
    }

    openNewWindow():void {
        window.open('/p/{0}'.f(this.id))
    }

    showInMainMenu():void {
        // 1 - find out if it's a workspace
        if (this.isWorkspace) {
            gd.spaces.workspaces.getByProject(this)?.openMenu()
            return
        }

        // 2 - project in projects or in workspaces
        this.space.openMenu({projectId: this.id})
    }


    debugTreeDisplay():void {

        console.log(this.name, "treeDisplay=", ItemDisplayDict[this.treeDisplay])

        _.map(this.treeChildren, (project)=>{
            project.debugTreeDisplay()
        })
    }

}
